import React from 'react';
import { NavBar } from '../../components/NavBar/NavBar';
import { Box } from '@mui/material';
import { mainSx, pageContainerSx } from './PageContainer.style';
import { ActionBar } from '../../components/ActionBar/ActionBar';
import { useAuth } from '../../hooks/useAuth/useAuth';

export const PageContainer = ({ title, logo, children }) => {
  const { isSignedIn } = useAuth();

  return (
    <Box sx={pageContainerSx}>
      <NavBar title={title} logo={logo} isSignedIn={isSignedIn} />

      <Box id="main" component="main" sx={mainSx}>
        {children}
        {isSignedIn && <ActionBar />}
      </Box>
    </Box>
  );
};
